import { render } from "./BetSlipMain.vue?vue&type=template&id=136a4fb2&scoped=true"
import script from "./BetSlipMain.vue?vue&type=script&lang=js"
export * from "./BetSlipMain.vue?vue&type=script&lang=js"

import "./BetSlipMain.vue?vue&type=style&index=0&id=136a4fb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136a4fb2"]])

export default __exports__